import styled from "styled-components";
import COLORS from "../../../designSystem/colors";


export const IconBox = styled.div<{ imageBackgroundColor?: string }>`
  width: 50px;
  height: 50px;
  background: ${({ imageBackgroundColor }) => imageBackgroundColor || "#ff6666b4"};
  border-radius: 12px;
  border: 1px solid ${COLORS.UI.BORDER.STANDARD};
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 32px auto 0 auto;
`;

export const Title = styled.div`
  font-size: 22px;
  font-weight: 600;
  color: ${COLORS.UI.TEXT.STANDARD};
  text-align: center;
  margin-bottom: 8px;
`;


export const Actions = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  width: 100%;
  box-sizing: border-box;
  padding: 0px 20px 20px 20px;
  > * {
    flex: 1 1 0;
    min-width: 120px;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;

